import { IsNumber, IsOptional, IsString } from 'class-validator';
import { BankSource } from '../enum/source';
import { PaymentDonationDto } from './paymentDonation.dto';
import { WebPaymentTypeEnum } from '../enum';
import { CustomerBrowserData } from '../models';

export class PaymentRequestV2Dto {
  @IsNumber()
  amount: number;

  @IsNumber()
  merchantId: number;

  @IsString()
  @IsOptional()
  source: BankSource;

  @IsOptional()
  successUrl?: string;

  @IsOptional()
  failUrl?: string;

  @IsOptional()
  capture?: boolean;

  @IsOptional()
  verify?: boolean;

  @IsOptional()
  notificationUrl?: string;

  @IsOptional()
  notificationData?: any;

  @IsOptional()
  donations?: PaymentDonationDto[];

  @IsOptional()
  @IsNumber()
  paymentMethodId?: number;

  @IsOptional()
  customerBrowserData?: CustomerBrowserData;

  @IsOptional()
  nameOnCard?: string;

  @IsOptional()
  merchantReference?: string;

  @IsOptional()
  paymentSolutionId?: string;

  @IsOptional()
  webPaymentType?: WebPaymentTypeEnum;

  @IsOptional()
  @IsNumber()
  referenceId?: number;

  @IsOptional()
  storeCard?: boolean;

  @IsOptional()
  entity?: string;

  @IsOptional()
  cardToken?: string;

  @IsOptional()
  initialTransactionId?: string;

  @IsOptional()
  cardOnFileInitiator?: string;

  @IsOptional()
  cardOnFileReason?: string;

  @IsOptional()
  cardOnFileType?: string;
}
